import styled, { css } from 'styled-components/macro';

export const StyledNavbar = styled.nav`
    background-color: ${({ theme }) => theme.color.bgBase};
    height: 90px;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 998;
    padding: 16px 32px;
    transition: padding 0.2s ease;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-left: 352px;

    @media (max-width: ${({ theme }) => `${theme.breakpoints.mobile}px`}) {
        display: none;
    }
`;

const badgeBase = css`
    padding: 2px 8px;
    font-weight: 500;
    margin: 4px;
    height: 29px;
    display: flex;
    align-items: center;
`;

export const StyledLevelBadge = styled.span`
    color: ${({ theme }) => theme.color.tertiary};
    background-color: ${({ theme }) => theme.color.bgTertiaryLight};
    border-radius: ${({ theme }) => theme.border.radiusBase};
    ${badgeBase}
`;

export const StyledScoreBadge = styled.span`
    color: ${({ theme }) => theme.color.secondary};
    background-color: ${({ theme }) => theme.color.bgSecondaryLight};
    border-radius: ${({ theme }) => theme.border.radiusBase};
    ${badgeBase}

    svg {
        margin-left: 5px;
    }
`;

export const StyledUserData = styled.div`
    margin: auto 18px auto 16px;
    height: 29px;
    border-left: ${({ theme }) => theme.border.base};
    font-weight: 500;
    display: flex;
    padding-left: 12px;
    align-items: center;
    ${({ isCurrentUserMPA }) =>
        isCurrentUserMPA &&
        css`
            cursor: pointer;
        `}

    img {
        margin-left: 12px;
        width: 29px;
        height: 29px;
        border-radius: 15px;
        object-fit: cover;
    }

    a {
        display: flex;
        align-items: center;
    }

    @media (max-width: ${({ theme }) => `${theme.breakpoints.xs}px`}) {
        white-space: nowrap;
        border-left: none;
    }
`;

export const IconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 49px;
    height: 49px;
    border-radius: ${({ theme }) => theme.border.radiusBase};
    cursor: pointer;

    &:hover {
        background-color: ${({ theme }) => theme.color.bgPrimaryLight};
    }

    ${({ faq }) =>
        faq &&
        css`
            margin-left: 8px;
        `}
`;
